const Q = require('q');
const crudService = require('services/crudService');
const logger = require('utilities/logger');
const model = require('model/model');

const TABLE = 'accountSetting';

const UNENROLL_MESSAGE_DISMISS = 'unenrollMessageDismiss';
const WHATS_NEW_DISMISS = 'whatsNewDismiss';
const SHOW_RESULTS_DISMISS = 'SHOW_RESULTS_DISMISS';
const PROFILE_UPDATE_2019_DISMISS = 'PROFILE_UPDATE_2019_DISMISS';
const RUN_END_DISMISS = 'RUN_END_DISMISS';
const REMOTE_SUPPORT_2020_DISMISS = 'REMOTE_SUPPORT_2020_DISMISS';
const REMOTE_SUPPORT_BTS_2020_DISMISS = 'REMOTE_SUPPORT_BTS_2020_DISMISS';
const REMOTE_IN_PERSON_2020_DISMISS = 'REMOTE_IN_PERSON_2020_DISMISS';
const PLEASE_REVIEW_SCHOOL_2020_DISMISS = 'PLEASE_REVIEW_SCHOOL_2020_DISMISS';
const STUDENT_NOTIFICATION_MODAL_DISMISS = 'STUDENT_NOTIFICATION_MODAL_DISMISS';
const SHOW_CLOSE_DISMISS = 'SHOW_CLOSE_DISMISS';
const SUMMER_OF_READWORKS_2023_DISMISS = 'SUMMER_OF_READWORKS_2023_DISMISS';
const PROFILE_UPDATE_2024_DISMISS = 'PROFILE_UPDATE_2024_DISMISS';

const analyticsUtilities = require('utilities/analyticsUtilities');

const fireEvent = analyticsUtilities.fireEvent;
const UPDATE_ACCOUNT_SETTING = analyticsUtilities.events.UPDATE_ACCOUNT_SETTING;

let settings = {
	WHATS_NEW_DISMISS,
	UNENROLL_MESSAGE_DISMISS,
	SHOW_RESULTS_DISMISS,
	PROFILE_UPDATE_2019_DISMISS,
	RUN_END_DISMISS,
	REMOTE_SUPPORT_2020_DISMISS,
	REMOTE_SUPPORT_BTS_2020_DISMISS,
	REMOTE_IN_PERSON_2020_DISMISS,
	PLEASE_REVIEW_SCHOOL_2020_DISMISS,
	STUDENT_NOTIFICATION_MODAL_DISMISS,
	SHOW_CLOSE_DISMISS,
	SUMMER_OF_READWORKS_2023_DISMISS,
	PROFILE_UPDATE_2024_DISMISS
};

let keys = Object.keys(settings).reduce((acc, tag) => {
	let key = settings[tag];
	acc[key] = true;
	return acc;
}, {});

const read = id => {
	let userContext = model.get('userContext');
	if (userContext && id && keys[id]) {
		return crudService.read(TABLE, { id }).then(setting => {
			let value = null;
			if (setting && setting.value) {
				value = setting.value;
			}
			return value;
		});
	} else if (id && !keys[id]) {
		logger.error('ID not specified in accountSettingsUtilities');
	}
	return Q.reject();
};

const update = (id, value) => {
	let userContext = model.get('userContext');
	if (userContext && id && keys[id]) {
		fireEvent(UPDATE_ACCOUNT_SETTING, {
			id: id,
			value
		});

		return crudService.update(TABLE, id, {
			value
		});
	} else if (id && !keys[id]) {
		logger.error('ID not specified in accountSettingsUtilities');
	}
	return Q.reject();
};

const CAMPAIGN_BANNERS = {
	profile: {
		body: 'Now is the time to update or complete your profile information!',
		link: '/my-account#!myAccountTab:teaching/',
		dismissKey: PROFILE_UPDATE_2019_DISMISS,
		dismissOnClick: true
	},
	remote: {
		body:
			'ReadWorks continues to offer expanded support for educators and families facing interrupted learning during the 2020-21 school year. We regularly update remote and hybrid resources for <a class="call-to-action-link" href="https://about.readworks.org/remote_learning.html" target="_blank">educators here</a> and <a class="call-to-action-link" href="https://about.readworks.org/parents_remote.html" target="_blank">families here</a>. Find our updated <a class="call-to-action-link" href="https://about.readworks.org/blog/our-renewed-commitment-and-support-for-the-2020-21-school-year" target="_blank">statement & policies here</a>. As always, as part of our nonprofit mission, ReadWorks is completely free.',
		routes: ['/'],
		dismissKey: REMOTE_SUPPORT_BTS_2020_DISMISS
	},
	sor: {
		// Summer Of ReadWorks
		body: 'Check out our Summer of ReadWorks workbooks for 2nd, 3rd, and 4th graders available now!',
		link: 'https://about.readworks.org/summer.html',
		routes: ['/'],
		dismissKey: SUMMER_OF_READWORKS_2023_DISMISS
	},
	remoteInPerson: {
		bodyIs: 'remote-in-person-campaign',
		routes: ['/find-content'],
		dismissKey: REMOTE_IN_PERSON_2020_DISMISS
	},
	pleaseReviewSchool: {
		bodyIs: 'please-review-school-campaign',
		routes: ['/find-content'],
		dismissOnClick: true,
		dismissKey: PLEASE_REVIEW_SCHOOL_2020_DISMISS
	},
	profile2024: {
		body: 'Important! Review your profile to update any necessary information by clicking here.',
		routes: ['ALL_ROUTES'],
		link: '/my-account#!myAccountTab:teaching/?utm_source=banner',
		dismissKey: PROFILE_UPDATE_2024_DISMISS,
		dismissOnLinkClick: true
	}
};

module.exports = {
	CAMPAIGN_BANNERS,
	read,
	update,
	settings
};
